import { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconList = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M16.3992 3.2H18.5992C19.1827 3.2 19.7423 3.43179 20.1549 3.84437C20.5674 4.25695 20.7992 4.81652 20.7992 5.4V20.8C20.7992 21.3835 20.5674 21.9431 20.1549 22.3556C19.7423 22.7682 19.1827 23 18.5992 23H5.39922C4.81574 23 4.25616 22.7682 3.84358 22.3556C3.431 21.9431 3.19922 21.3835 3.19922 20.8V5.4C3.19922 4.81652 3.431 4.25695 3.84358 3.84437C4.25616 3.43179 4.81574 3.2 5.39922 3.2H7.59922M11.9992 10.9H16.3992M11.9992 16.4H16.3992M7.59922 10.9H7.61022M7.59922 16.4H7.61022M8.69922 1H15.2992C15.9067 1 16.3992 1.49249 16.3992 2.1V4.3C16.3992 4.90751 15.9067 5.4 15.2992 5.4H8.69922C8.09171 5.4 7.59922 4.90751 7.59922 4.3V2.1C7.59922 1.49249 8.09171 1 8.69922 1Z"
      stroke="currentColor"
      strokeWidth="1.32"
      strokeLinecap="square"
    />
  </SvgIcon>
));

IconList.displayName = 'IconList';
